import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from '@angular/http';
import { AdalService } from '../adal/adal.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { AppSettingsService } from '../services/appsettings.service';
import { Tool } from './main.tool';

@Component({
    selector: 'main',
    template: require('./main.component.html')
})
export class MainComponent {
    public message: string;
    public values: any[];
    public userInfo: any;
    public toolSet: Tool[];
    public selectedItem: number;
    public url: string;
    
    constructor(
        private router: Router,
        private adalService: AdalService,
        private appSettingsService: AppSettingsService
    ) {
        this.url = window.location.pathname;
        this.userInfo = this.adalService.userInfo;
        this.appSettingsService.setRedirectPath(window.location.pathname);
        this.appSettingsService.setRedirectUri(window.location.origin + window.location.pathname);
        this.adalService.init(this.appSettingsService.adalConfig);
        this.adalService.handleWindowCallback();
        if (this.adalService.userInfo.isAuthenticated) {

            this.router.navigate([this.appSettingsService.adalConfig.redirectPath]);
        }
        else {
            this.adalService.clearCache();
            this.adalService.login();
        }

        this.toolSet = [
            new Tool('Retrieve System Details', '/main/RetrieveSystemDetails'),
            new Tool('System Type Management', '/main/SystemTypeManagement'),
            new Tool('Access Management', '/main/accessmanagement'),
            new Tool('Model Type Creator', '/main/model-type-registration'),
            new Tool('Custom Application Creation', '/main/CustomApplicationCreation'),
            new Tool('Portal Admin', '/main/PortalAdmin'),
            new Tool('User Management service in ForgeRock ','/main/UserManagement'),
            new Tool('Fine Grained Auth Management', '/main/FineGrainedAuthManagement'),
            new Tool('System Services Manager', '/main/system-service-manager'),
            new Tool('Onboarding New User in Forgerock', '/main/OnboardingUserForgerock'),
            new Tool('Updating Forgerock Uris', '/main/forgerock-uri-updation'),
            new Tool('Manage Device CA Certificates', '/main/manage-device-ca-certificates'),
            ...this.getTenantTools(this.appSettingsService.adalConfig.isTenantEnabled)
        ];
        
    }
    
    public listClick(newValue) {
        this.selectedItem = newValue;
        this.url = '';
    }

    public updateUserInfo(userInfo: any) {
        this.userInfo = userInfo;
    }

    public logout() {
        this.adalService.logOut();
        this.adalService.clearCache();
    }

    getTenantTools(isTenantEnabled: boolean): Array<Tool> {
        if (isTenantEnabled) {
            return [
                new Tool('Iot Hub Device Manager', '/main/SentienceDeviceManager'),
                new Tool('Annotation Stream Manager', '/main/AnnotationStreamManagement'),
                new Tool('Annotation Stream Manager V2', '/main/AnnotationStreamManagementV2'),
                new Tool('Retrieve System Health', '/main/RetrieveSystemHealth'),
                new Tool('Tenant Details Remover','/main/tenant-details-remover')
            ];
        } else {
            return [];
        }
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/main.component.ts
 **/